import { SideNavigation, SideNavigationProps } from '@cloudscape-design/components';
import { useLocation, useNavigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';

export function UserSideNavigation() {
    const navigate = useNavigate();
    const location = useLocation();
    const user = useUser();

    // Tools available to read-only and admin users alike.
    const readableToolItems: SideNavigationProps.Item[] = (user.isAdmin || user.isReadOnly)
        ? [
            { type: 'link', text: 'SeekingAlpha Articles', href: '/seeking-alpha' },
            { type: 'link', text: 'Alpha Analysis', href: '/alpha' },
            { type: 'link', text: 'Alpha Picks', href: '/alpha-picks' },
            { type: 'link', text: 'Job Monitoring', href: '/job-monitoring' },
            { type: 'link', text: 'Webhook notifications', href: '/webhooks' },
        ]
        : [];

    const adminToolItems: SideNavigationProps.Item[] = user.isAdmin
        ? [
            { type: 'link', text: 'Portfolio', href: '/portfolio' },
            { type: 'link', text: 'Trading 212 ISA', href: '/trading212-isa' },
            { type: 'link', text: 'Trading 212 CFD', href: '/trading212-cfd' },
            { type: 'link', text: 'Market Cap', href: '/market-cap' },
        ]
        : [];

    const adminOnlyItems: SideNavigationProps.Item[] = user.isAdmin
        ? [
            { type: 'link', text: 'User Management', href: '/admin/users' },
            { type: 'link', text: 'Admin Jobs', href: '/admin/jobs' },
            { type: 'link', text: 'Trading 212', href: '/admin/trading212' },
            { type: 'link', text: 'Stock Prices', href: '/admin/stock-prices' },
            { type: 'link', text: 'Credentials Management', href: '/credentials' },
        ]
        : [];

    // For admin users, keep the section structure ("Tools" / "Administration") so
    // the longer list is easier to scan. For read-only users, the list is short
    // enough that section labels add noise — render flat instead. (C4)
    const navigationItems: SideNavigationProps.Item[] = user.isAdmin
        ? [
            { type: 'section', text: 'Tools', items: [...readableToolItems, ...adminToolItems] },
            { type: 'divider' },
            { type: 'section', text: 'Administration', items: adminOnlyItems },
        ]
        : readableToolItems;

    return (
        <SideNavigation
            activeHref={location.pathname}
            header={{
                href: '/',
                text: 'Juhsis',
            }}
            items={navigationItems}
            onFollow={(event) => {
                event.preventDefault();
                if (!event.detail.external && event.detail.href) {
                    navigate(event.detail.href);
                }
            }}
        />
    );
}
